module.exports = __webpack_public_path__ + "img/cash-u.0e3cdf1a.svg";